// extracted by mini-css-extract-plugin
export default {"cookieBar":"cookieBar_cookieBar__Q2Cg+","cookieBarText":"cookieBar_cookieBarText__4etwB","cookieBarContainer":"cookieBar_cookieBarContainer__aAP1Q","link":"cookieBar_link__P4RHA"};